import { Select } from '@mantine/core';
import { ChevronDown } from 'react-feather';
import { Icon } from '@/components/Icon/Icon';
import classes from './ReleaseSelector.module.css';
import type { ReleaseOption } from './ReleaseSelector';

type Props = {
  options: ReleaseOption[];
  selectedId: string;
  onChange: (id: string) => void;
  customClassName?: string;
};

export const ReleaseSelectorProgram = ({
  options,
  selectedId,
  onChange,
  customClassName,
}: Props) => (
  <div className={`${customClassName ?? ''} ${classes.program}`}>
    <Select
      data={options}
      onChange={(value) => value && onChange(value)}
      value={selectedId || null}
      size="md"
      rightSection={<Icon Component={ChevronDown} size={16} />}
      classNames={{
        input: classes.programSelectInput,
      }}
    />
  </div>
);
